<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-12.col-xl-3.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            i.fa.fa-gamepad
          ProviderLookup(
            v-if="displayTable"
            size="sm"
            type="array"
            :operatorID="operatorID"
            v-model="provider"
            :disabled="loading"
            category="OTHERS"
            :isAll="true"
            :isReport="true"
            @input="getGameResult(true)"
          )
      .form-group.col-12.col-xl-6.mb-1
        DateRangePicker(:value="dateRange" @update="getData" opens="left" v-if="displayTable")
      .form-group.col-12.mb-1
        SubmitButton.mr-2(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getGameResult(true)"
          variant="primary"
          size="sm"
        )
        jsonToExcel(v-if="gameResultList.length > 0" mode="GameResultOthers" tbl="tblGameResultOthers" :date="dateRange")
        gameResultOthersExport(v-if="gameResultList.length > 0" :tbl="gameResultList" :totalTbl="grandTotalList" tblId="tblGameResultOthers")
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)")
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-resizable#tblGameResultOthers(style="width:100%;" v-if="displayTable")
            thead.thead-light(v-columns-resizable)
              tr
                th.sticky-position(width="3%")
                  span #
                th.sticky-position(width="17%")
                  span(:title="$t('ui.result_id')") {{ $t('ui.result_id') }}
                th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('bet_time')")
                  .d-flex.justify-content-between.align-items-center
                    span(:title="$t('ui.bet_time')") {{ $t('ui.bet_time') }}
                    i(:class="changeSortKey('bet_time')")
                th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('turnover')")
                  .d-flex.justify-content-between.align-items-center
                    span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                    i(:class="changeSortKey('turnover')")
                th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('valid_turnover')")
                  .d-flex.justify-content-between.align-items-center
                    span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
                    i(:class="changeSortKey('valid_turnover')")
                th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('payout')")
                  .d-flex.justify-content-between.align-items-center
                    span(:title="$t('ui.payout')") {{ $t('ui.payout') }}
                    i(:class="changeSortKey('payout')")
                th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('winlose')")
                  .d-flex.justify-content-between.align-items-center
                    span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                    i(:class="changeSortKey('winlose')")
                th.sticky-position.text-right(width="9%")
                  span(:title="$t('ui.game_type')") {{ $t("ui.game_type") }}
                th.sticky-position.text-right(width="11%")
                  span(:title="$t('ui.game_name')") {{ $t("ui.game_name") }}
            tbody.clusterize-content
              tr(v-if="gameResultList.length == 0")
                td(colspan="9").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in gameResultList")
                td
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  //- span.font-weight-bold.text-info(:title="item.result_id" v-if="!resultDetailProvider.includes(item.provider_code)")
                  //-   b-link.text-info(href="javascript:void(0);" @click="getResultDetail(item)" :title="item.result_id") {{ item.result_id }}
                  //- span(v-else :title="item.result_id") {{ item.result_id }}
                  span.font-weight-bold.text-info(:title="item.result_id" v-if="item.has_result")
                    b-link.text-info(href="javascript:void(0);" @click="getResultDetail(item)" :title="item.result_id") {{ item.result_id }}
                  span(v-else :title="item.result_id") {{ item.result_id }}
                td.text-right
                  span(:title="$moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss') }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.payout)" :title="$n(item.payout, 'currency')") {{ $n(item.payout, 'currency') }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                td.text-right
                  span(:title="item.game_type") {{ item.game_type }}&nbsp;
                td.text-right
                  span(:title="item.game_name") {{ item.game_name }}&nbsp;
              tr(v-if="showTotal")
                td.text-right(colspan="3")
                  span.d-block {{ $t("ui.sub_total") }}
                  span {{ $t("ui.grand_total") }}
                td.text-right
                  span.d-block.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnover)" :title="$n(subTotalTurnover, 'currency')") {{ $n(subTotalTurnover, 'currency') }}
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnover)" :title="$n(grandTotalTurnover, 'currency')") {{ $n(grandTotalTurnover, 'currency') }}
                td.text-right
                  span.d-block.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnover)" :title="$n(subTotalValidTurnover, 'currency')") {{ $n(subTotalValidTurnover, 'currency') }}
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnover)" :title="$n(grandTotalValidTurnover, 'currency')") {{ $n(grandTotalValidTurnover, 'currency') }}
                td.text-right
                  span.d-block.font-weight-bold(:class="$helpers.fontClassName(subTotalPayout)" :title="$n(subTotalPayout, 'currency')") {{ $n(subTotalPayout, 'currency') }}
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalPayout)" :title="$n(grandTotalPayout, 'currency')") {{ $n(grandTotalPayout, 'currency') }}
                td.text-right
                  span.d-block.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLose)" :title="$n(subTotalWinLose, 'currency')") {{ $n(subTotalWinLose, 'currency') }}
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLose)" :title="$n(grandTotalWinLose, 'currency')") {{ $n(grandTotalWinLose, 'currency') }}
                td
                td
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateTimeRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import jsonToExcel from "@/library/jsonToExcel.vue";
import ProviderLookup from "@/library/ProviderLookup.vue";
import gameResultOthersExport from "@/components/report/gameResultOthersExportFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel,
    ProviderLookup,
    gameResultOthersExport
  },
  props: {
    currTab: {
      type: String,
      default: ''
    },
    memberID: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    loading: false,
    gameResultList: [],
    currentPage: 1,
    totalRow: 0,
    // search: "",
    provider: "",
    subTotalTurnover: 0,
    grandTotalTurnover: 0,
    subTotalValidTurnover: 0,
    grandTotalValidTurnover: 0,
    subTotalWinLose: 0,
    grandTotalWinLose: 0,
    subTotalPayout: 0,
    grandTotalPayout: 0,
    showTotal: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null,
    },
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    sortKey: "bet_time",
    sortType: "desc",
    resultDetailUrl: "",
    resultDetailProvider: config.resultDetailProvider,
    displayTable: false
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeMemberReport;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
  },
  mounted: function() {  },
  destroyed: function() {
    var json = {
      start_date: null,
      end_date: null,
      provider: null
    };
    this.$store.dispatch("user/setGameResultOthersParam", json);
  },
  methods: {
    refresh() {
      this.displayTable = false;
      if (this.$store.getters.gameResultOthers.provider != null && this.$store.getters.gameResultOthers.provider != '') {
        this.provider = this.$store.getters.gameResultOthers.provider;
      }
      if (this.$store.getters.gameResultOthers.start_date && this.$store.getters.gameResultOthers.end_date) {
        this.dateRange.startDate = this.$store.getters.gameResultOthers.start_date;
        this.dateRange.endDate = this.$store.getters.gameResultOthers.end_date;
      } else {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD 00:00:00');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD 23:59:59');
      }

      this.getGameResult(true);

      setTimeout(() => {
        this.displayTable = true;
      }, 10);
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getGameResult(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD HH:mm:ss');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD HH:mm:ss');
      this.getGameResult(true);
    },
    getResultDetail(e) {
      this.getResultDetailAPI(e);
    },
    getResultDetailAPI: function(item) {
      let url = config.resultDetail["oneUrl"];
      var json = {
        ticket_id: item.result_id
      };

      if(item.aggregator != null) {
        json.aggregator = item.aggregator
      }

      if (url != "") {
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (response.data.detail_url != null && response.data.detail_url != "") {
                  this.feedback.success = true;
                  this.feedback.status = "OK";
                  this.resultDetailUrl = response.data.detail_url;
                } else {
                  this.feedback.success = false;
                  if (response.data.status_desc) {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.status"), response.data.status_desc, "error");
                  }
                  else {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.status"), this.$t("error.failedToGetResultUrl"), "error");
                  }
                }

                if (this.resultDetailUrl != "" && this.feedback.success == true)
                  window.open(this.resultDetailUrl, "info", "toolbar=no,scrollbars=no,resizable=no,top=0,left=0,width=480,height=640");
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        if (this.resultDetailUrl != "")
          window.open(this.resultDetailUrl, "info", "toolbar=no,scrollbars=no,resizable=no,top=0,left=0,width=480,height=640");
      }
    },
    setGameResultOthersParam: function() {
      var json = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        provider: this.provider
      };
      this.$store.dispatch("user/setGameResultOthersParam", json);
    },
    getGameResult: function(isSearch) {
      if (this.checkDateRange()) {

        this.setGameResultOthersParam();
        let url = config.gameResultOthersUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          member_id: this.memberID,
          provider_code: this.provider,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotal()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.gameresult.length > 0) {
                    this.showTotal = true
                    response.data.ds.gameresult.forEach(value => {
                      this.subTotalTurnover = parseFloat(this.subTotalTurnover) + parseFloat(value["turnover"]);
                      this.subTotalValidTurnover = parseFloat(this.subTotalValidTurnover) + parseFloat(value["valid_turnover"]);
                      this.subTotalWinLose = parseFloat(this.subTotalWinLose) + parseFloat(value["winlose"]);
                      this.subTotalPayout = parseFloat(this.subTotalPayout) + parseFloat(value["payout"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalTurnover = response.data.ds.grand_total[0]["turnover"];
                      this.grandTotalValidTurnover = response.data.ds.grand_total[0]["valid_turnover"];
                      this.grandTotalWinLose = response.data.ds.grand_total[0]["winlose"];
                      this.grandTotalPayout = response.data.ds.grand_total[0]["payout"];
                    }

                    this.grandTotalList = response.data.ds.grand_total
                    this.gameResultList = response.data.ds.gameresult;
                    this.totalRow = response.data.ds.gameresult.length > 0 ? this.gameResultList[0]["totalrows"] : 0
                  } else {
                    this.clearTotal()
                  }
                } else {
                  this.clearTotal()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotal();
        this.gameResultList = [];
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    clearTotal() {
      this.showTotal = false;
      this.gameResultList = []
      this.totalRow = 0
      this.subTotalTurnover = 0
      this.grandTotalTurnover = 0
      this.subTotalValidTurnover = 0
      this.grandTotalValidTurnover = 0
      this.subTotalWinLose = 0
      this.grandTotalWinLose = 0
      this.subTotalPayout = 0
      this.grandTotalPayout = 0
    },
    changedPageSize: function(pageSize) {
      if(this.currTab != 'gameresultothers') return
      this.$store.dispatch("layout/setPageSizeMemberReport", pageSize);
      this.currentPage = 1;
      this.getGameResult(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getGameResult();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>